<template>
  <el-dialog
    :visible="visible"
    append-to-body
    top="50px"
    width="fit-content"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <div class="list-3d-carousel">
      <el-carousel
        class="h-100"
        :autoplay="false"
        arrow="hover"
      >
        <el-carousel-item
          v-for="item in listLink"
          :key="item"
          >
          <iframe
            :src="item"
            frameborder="0"
            width="100%"
            height="100%" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'Preview3DPopup',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      listLink: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<style lang="scss">
.list-3d-carousel {
  width: 1200px;
  aspect-ratio: 16/9;
  padding: 16px 0;
  .el-carousel {
    height: 100%;
    .el-carousel__container {
      height: 100% !important;
    }
  }
}
</style>
